import { API_ROUTES, apiGet } from '@configure/apiConfig';
import { useEffect, useState, useRef } from 'react';

function useLeadershipData() {
  const [leaderShipResources, setLeaderShipResources] = useState([]);
  const fetchedOnce = useRef(false);

  useEffect(() => {
    const fetchResources = async () => {
      if (fetchedOnce.current) return;
      fetchedOnce.current = true;

      try {
        const response = await apiGet(`${API_ROUTES.GET_ALL_RESOURCES}?resourceType=deal_reviewers`);
        if (Array.isArray(response.data?.data)) {
          setLeaderShipResources(response.data.data);
        } else {
          console.error("Invalid response format");
        }
      } catch (error) {
        console.error("Error fetching resources:", error);
      }
    };

    fetchResources();
  }, []);

  return { leaderShipResources };
}

export default useLeadershipData;
